import { render } from "./AssetSelection.vue?vue&type=template&id=6589358c"
import script from "./AssetSelection.vue?vue&type=script&lang=js"
export * from "./AssetSelection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__